import React, { useRef ,useEffect, forwardRef } from 'react';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import FixedBg from "./FixedBg";
import Firstview from "./Firstview";
import LineUp from "./LineUp";
import Menu from "./Menu";
import ProductBellini from "./ProductBellini";
import ProductMilky from "./ProductMilky";
import SetboxBellini from "./SetboxBellini";
import SetboxMilky from "./SetboxMilky";
import Novelty from "./Novelty";
import Footer from "./Footer";

import "../styles/reset.scss";
import "../styles/common.scss";

// import '../styles/App.css'

// require('../styles/common.scss');


const Content = forwardRef((props, ref) => {

  const menu = useRef();
  const lineup = useRef();
  const footer = useRef();

  // const [load, setLoad] = useState(true);

  // const pageLoaded = () => {
  //   document.addEventListener("DOMContentLoaded", () => {
  //     setTimeout(() => {
  //         setLoad(false)
  //     }, 2500);
  //   });
  // }

  useEffect(() => {

        gsap.registerPlugin(ScrollTrigger);
        // gsap.set(menu.current, 
        //   {autoAlpha: 0,}
        // );

        gsap.set('.main', {
          autoAlpha: 0,
        })
        gsap.to('.main', {
          autoAlpha: 1,
          duration: 1.5,
        })

        gsap.to(menu.current, {
          autoAlpha: 1, 
          scrollTrigger: {
              trigger: lineup.current,
              start: 'top bottom', 
              // toggleClass: {targets: menu.current, className: "is-show"},
              toggleActions: 'play none none reset',
              normalizeScroll: true,
              ignoreMobileResize: true
          },
        });
        gsap.to(menu.current, {
          autoAlpha: 1, 
          scrollTrigger: {
              trigger: footer.current,
              start: 'top bottom', 
              toggleClass: {targets: menu.current, className: "is-hidden"},
              normalizeScroll: true,
              ignoreMobileResize: true
              // markers: true,
          },
        });


  }, []);
  
  return (
    <section className="main">
      <FixedBg/>
      <Firstview />
      <Menu ref={menu}/>
      <LineUp ref={lineup}/>
      <ProductBellini />
      <SetboxBellini />
      <ProductMilky />
      <SetboxMilky />
      <Novelty />
      <Footer ref={footer}/>
    </section>
  )
})

export default Content
